import styled from "styled-components";

export const CopyrightContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  color: gray;
`;
